// Stripe subscription Actions
import {IStripeViewSettings} from '@interfaces/subscription-plan';
import {ConfirmCardPaymentData, ConfirmCardSetupData, PaymentIntent} from '@stripe/stripe-js';

export class GetUserSubscription {
  static readonly type = '[Stripe] Get User subscription';
  constructor(public type: 'fullDate' | 'onlySubscription' = 'fullDate') {
  }
}

export class GetStripePlans {
  static readonly type = '[Stripe] Get Stripe plans';
}

export class GetPaymentMethods {
  static readonly type = '[Stripe] Get payment methods';
}

export class GetPaymentMethod {
  static readonly type = '[Stripe] Get payment method';

  constructor(public paymentMethodId: string) {
  }
}

export class GetDefaultPaymentMethod {
  static readonly type = '[Stripe] Get default payment method';

  constructor(public paymentMethodId = 'default') {
  }
}

export class UpdateStripeViewSettings {
  static readonly type = '[Stripe] Update Stripe View Settings';

  constructor(public options?: IStripeViewSettings) {
  }
}

export class GetStripeInvoice {
  static readonly type = '[Stripe] Get Stripe invoice';
}

export class CreateSubscription {
  static readonly type = '[Stripe] Create subscription';

  constructor(public data: { paymentMethodId: string, planId: string, devices: number }) {
  }
}

export class CreateSubscriptionIntent {
  static readonly type = '[Stripe] Create subscription intent';

  constructor(public data: { planId: string, devices: number }, public card: ConfirmCardSetupData) {
  }
}

export class RunStrongSecure {
  static readonly type = '[Stripe] Run strong secure';

  constructor(public intent: PaymentIntent, public card?: ConfirmCardPaymentData) {
  }
}

export class UpdateSubscription {
  static readonly type = '[Stripe] Update subscription';

  constructor(
    public subsId: string,
    public data: { plan: string } | { cancel: boolean } | { resume: boolean } | { quantity: number }
  ) {
  }
}

export class  GetPaymentIntent {
  static readonly type = '[Stripe] Get payment intent';

  constructor(public id: string) {
  }
}

export class DeletePaymentMethod {
  static readonly type = '[Stripe] Delete payment method';

  constructor(public id: string) {
  }
}

export class AddPaymentMethod {
  static readonly type = '[Stripe] Add payment method';

  constructor(public paymentMethodId: string | null, public asDefault: boolean, public card?: ConfirmCardSetupData) {
  }
}

export class ConfirmPayment {
  static readonly type = '[Stripe] confirm payment';
  constructor(public clientSecret: string, public data: ConfirmCardPaymentData) {
  }
}

export class GetUserForPayment {
  static readonly type = '[Stripe] Get User';
}
